import { readConsent } from './consent.ts';
import type * as SignalsModule from '../../signals/index.ts';

/**
 * İzleyicinin yükleyicideki CEPHESİ (M3 §3.1.1).
 *
 * İzlemenin kendisi burada DEĞİL, izin kapısının arkasındaki sinyal paketinde. Sebebi kural:
 * Mod 0'da hiçbir olay gönderilmiyor, hiçbir depolama anahtarı yazılmıyor (AK-M3-01) — yani
 * olay kuyruğu, varlık yoklaması ve bütün algılayıcılar izinsiz ziyaretçide ÖLÜ AĞIRLIK.
 * TR'de varsayılan izinsizlik olduğu için ziyaretçilerin çoğu onları hiç indirmiyor.
 *
 * Geriye kalan iş üç satır: izni oku, izin geldiğinde paketi indir, o ana kadarki çağrıları
 * sırayla ilet.
 */

export type Tracker = SignalsModule.Tracker;
export type TrackerOptions = SignalsModule.TrackerOptions;

/** İzin sonradan gelebilir (CMP bandı); yoklama yalnız gelene kadar sürüyor. */
const WATCH_MS = 2000;

const loadSignals = (src: string | undefined): Promise<typeof SignalsModule> =>
  import.meta.env.DEV
    ? import('../../signals/index.ts')
    : import(/* @vite-ignore */ new URL('signals.js', src ?? location.href).href);

export function startTracker(options: TrackerOptions): Tracker {
  let live: Tracker | undefined;
  /** Paket inene kadarki çağrılar; sıraları korunuyor. */
  const queued: ((tracker: Tracker) => void)[] = [];

  const later = (call: (tracker: Tracker) => void): void => {
    if (live === undefined) queued.push(call);
    else call(live);
  };

  const load = (): void => {
    if (live !== undefined || readConsent() === 0) return;
    void loadSignals(options.scriptSrc)
      .then((module) => {
        live = module.startTracking(options);
        for (const call of queued) call(live);
        queued.length = 0;
        return undefined;
      })
      .catch(() => {
        /* Paket inmezse site bozulmaz; yalnız izleme ve proaktif yüzey olmaz. */
      });
  };

  load();
  const timer = setInterval(() => {
    if (live === undefined) load();
    else clearInterval(timer);
  }, WATCH_MS);

  return {
    track: (name, props) => later((tracker) => tracker.track(name, props)),
    note: (name) => later((tracker) => tracker.note(name)),
    connectChat: (open, closeLabel) => later((tracker) => tracker.connectChat(open, closeLabel)),
  };
}
